import Person from './person';
import PersonAccess from './person-access';

export default {Person, PersonAccess}
export { Person, PersonAccess }
